import React from "react";
import "./AboutSection.scss";
import { AllImages } from "../../Assets/Images/AllImages";
import Button from "../../Common/Button/Button";

import user from "../../Common/JsonFiles/rohan.json";
import pdf from "../../Common/JsonFiles/RohanCV.json";

const AboutSection = () => {
  const downloadCV = () => {
    const linkSource = `data:application/pdf;base64,${pdf.base64}`;
    const downloadLink = document.createElement("a");
    const fileName = `${user.name}.pdf`;

    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  };

  return (
    <div className="about-section-container">
      <div className="about-content">
        <div className="section-heading">
          <span className="heading-i-am">Hi, I'm</span>
        </div>
        <div className="sub-heading">
          Coding is poetry in motion, where ideas come to life.
        </div>

        <div className="about-avatar">
          <img
            src={AllImages.ProfileAvatar}
            alt=""
            width={"200px"}
            height={"200px"}
          />
        </div>

        <div className="about-illustration">
          <img src={AllImages.TechDevices} alt="" />
        </div>

        <div className="about-me-content">
          <div className="about-me-heading">
            Hi, I’m Rohan. Nice to meet you.
          </div>
          <div className="about-me-description">{user.description}</div>
          {/* <div>
            <Button
              className=""
              name="Download Resume"

              // onClick={() => downloadCV()}
            />
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default AboutSection;
